import React from "react";
import "./TocListItem.css";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Draggable from "react-draggable";
import { connect } from "react-redux";
import {
  modifyOneTocDataAction,
  snapShotTocStateAction,
  recoverLastMoveAction,
  deleteTocArticleAction,
  setLockingIDAction,
  createManualArticleAction,
  saveTempTocAction
} from "../../redux/actions/tocEditPanel";
import { generateUniqueID } from "../../utils/utils";

class TocListItem extends React.Component {
  constructor(props) {
    super(props);

    this.onStartPageChange = this.onStartPageChange.bind(this);
    this.onEndPageChange = this.onEndPageChange.bind(this);
    this.onTitleChange = this.onTitleChange.bind(this);
    this.handleStartDrag = this.handleStartDrag.bind(this);
    this.handleDrag = this.handleDrag.bind(this);
    this.handleStopDrag = this.handleStopDrag.bind(this);
    this.deleteClicked = this.deleteClicked.bind(this);
    this.lockClicked = this.lockClicked.bind(this);
    this.focus = this.focus.bind(this);
    this.blur = this.blur.bind(this);
    this.scrollTitleToBottom = this.scrollTitleToBottom.bind(this);
    this.createClicked = this.createClicked.bind(this);

    this.tocPanelCardRef = React.createRef();
    this.tocTitleRef = React.createRef();
    this.lastClickBtn = 0;

    this.state = {
      style: { zIndex: 0 },
      position: { x: 0, y: 0 },
      isMoving: false,
      startScrollY: null
    };
  }

  lockClicked() {
    const {
      isSaveLoading,
      articleID,
      lockingID,
      setLockingIDAction
    } = this.props;

    if (isSaveLoading) {
      return;
    }

    if (lockingID === articleID) {
      setLockingIDAction({ lockingID: null });
    } else {
      setLockingIDAction({ lockingID: articleID });
    }
  }

  createClicked() {
    const {
      idx,
      isSaveLoading,
      createManualArticleAction,
      setLockingIDAction,
      issueID,
      saveTempTocAction,
      maxPage
    } = this.props;

    if (isSaveLoading) {
      return;
    }

    let insertIndex = idx;

    if (idx < 0) {
      return;
    }

    const newID = generateUniqueID();
    createManualArticleAction({
      newID,
      insertIndex,
      maxPage
    });

    setLockingIDAction({ lockingID: newID });
    saveTempTocAction(issueID);
  }

  deleteClicked() {
    if (this.props.isSaveLoading) {
      return;
    }

    const {
      article,
      deleteTocArticleAction,
      issueID,
      saveTempTocAction
    } = this.props;

    deleteTocArticleAction({ id: article.id });
    saveTempTocAction(issueID);
  }

  focus() {
    const { article, snapShotTocStateAction } = this.props;
    this.title = article.title;
    this.firstPage = article.first_page;
    this.lastPage = article.last_page;

    snapShotTocStateAction();
  }

  blur() {
    const { article, recoverLastMoveAction } = this.props;

    if (
      this.title === article.title &&
      this.firstPage === article.first_page &&
      this.lastPage === article.last_page
    ) {
      recoverLastMoveAction();
    }

    this.title = null;
    this.firstPage = null;
    this.lastPage = null;
  }

  onStartPageChange(event) {
    if (this.props.isSaveLoading) {
      return;
    }

    const page = event.target.value;
    if (isNaN(page)) {
      return;
    }

    const {
      articleID,
      modifyOneTocDataAction,
      issueID,
      saveTempTocAction
    } = this.props;

    modifyOneTocDataAction({ id: articleID, first_page: page });
    saveTempTocAction(issueID);
  }

  onEndPageChange(event) {
    if (this.props.isSaveLoading) {
      return;
    }

    const page = event.target.value;
    if (isNaN(page)) {
      return;
    }

    const {
      articleID,
      modifyOneTocDataAction,
      issueID,
      saveTempTocAction
    } = this.props;

    modifyOneTocDataAction({ id: articleID, last_page: page });
    saveTempTocAction(issueID);
  }

  onTitleChange(event) {
    if (this.props.isSaveLoading) {
      return;
    }

    const {
      articleID,
      modifyOneTocDataAction,
      issueID,
      saveTempTocAction
    } = this.props;

    modifyOneTocDataAction({ id: articleID, title: event.target.value });
    saveTempTocAction(issueID);
  }

  handleStartDrag(e) {
    if (this.props.isSaveLoading) {
      return false;
    }

    const { getPanelPosition } = this.props;

    this.setState({
      style: { zIndex: 100 },
      isMoving: true,
      startScrollY: getPanelPosition().scrollTop
    });
  }

  handleDrag(e) {
    if (this.props.isSaveLoading) {
      return;
    }

    const { getPanelPosition, setCurDragY } = this.props;

    const newY = getRelXY(e, getPanelPosition()).y;

    if (this.lastFireY == null || Math.abs(newY - this.lastFireY) > 10) {
      setCurDragY(newY);
      this.lastFireY = newY;
      this.setState({});
    }
  }

  handleStopDrag(e) {
    if (this.props.isSaveLoading) {
      return;
    }

    const { mergeToc, setCurDragY, article } = this.props;

    const concatOnly = this.lastClickBtn === 2;
    const mergeOK = mergeToc(article, concatOnly);

    setCurDragY(-1);

    if (mergeOK) {
      return;
    }

    this.setState({
      style: { zIndex: 0 },
      position: { x: 0, y: 0 },
      isMoving: false,
      startScrollY: null
    });
  }

  componentDidMount() {
    const { idx, article, updateScrollTop } = this.props;

    const topBound =
      this.tocPanelCardRef == null ? 0 : this.tocPanelCardRef.offsetTop;
    const height =
      this.tocPanelCardRef == null ? 0 : this.tocPanelCardRef.clientHeight;

    const positionData = {
      id: article.id,
      topBound: topBound,
      btmBound: topBound + height,
      article: article
    };

    setTimeout(() => {
      updateScrollTop(idx, positionData, null);
    }, 0);
  }

  componentDidUpdate(prevProps) {
    const { idx, article, updateScrollTop } = this.props;

    const topBound =
      this.tocPanelCardRef == null ? 0 : this.tocPanelCardRef.offsetTop;
    const height =
      this.tocPanelCardRef == null ? 0 : this.tocPanelCardRef.clientHeight;

    const positionData = {
      id: article.id,
      topBound: topBound,
      btmBound: topBound + height,
      article: article
    };

    setTimeout(() => {
      updateScrollTop(idx, positionData, prevProps.idx);
    }, 0);

    if (article.title !== prevProps.article.title) {
      this.scrollTitleToBottom();
    }
  }

  componentWillUnmount() {
    const { idx, article, deleteScrollTop } = this.props;

    const positionData = {
      id: article.id
    };

    setTimeout(() => {
      deleteScrollTop(idx, positionData);
    }, 0);
  }

  scrollTitleToBottom() {
    if (this.tocTitleRef != null) {
      this.tocTitleRef.scrollTop = this.tocTitleRef.scrollHeight;
    }
  }

  render() {
    const {
      idx,
      article,
      articleID,
      getPanelPosition,
      shouldHighlight,
      isSaveLoading,
      lockingID
    } = this.props;
    const { style, position, isMoving, startScrollY } = this.state;

    const isLocking = articleID === lockingID;

    const highlight = !isMoving && (shouldHighlight || isLocking);

    const yOffset =
      startScrollY == null ? 0 : getPanelPosition().scrollTop - startScrollY;

    return (
      <Draggable
        allowAnyClick={true}
        onMouseDown={e => {
          this.lastClickBtn = e.button;
        }}
        handle=".toc_handle"
        cancel=".toc_delete_btn"
        position={position}
        positionOffset={{ x: 0, y: yOffset }}
        onStart={this.handleStartDrag}
        onDrag={this.handleDrag}
        onStop={this.handleStopDrag}
      >
        <Card
          text="dark"
          bg={highlight ? "warning" : null}
          style={style}
          className="toc_list_card"
          ref={el => (this.tocPanelCardRef = el)}
        >
          <Card.Header
            onContextMenu={e => e.preventDefault()}
            className="toc_handle"
            style={{ paddingTop: "5px", paddingBottom: "5px" }}
          >
            <span className="toc_order_number">{idx}</span>
            <Button
              disabled={isSaveLoading}
              variant={isLocking ? "primary" : "secondary"}
              size="sm"
              className="toc_delete_btn"
              onClick={this.lockClicked}
            >
              <span className="fa fa-lock" />
            </Button>
            <Button
              disabled={isSaveLoading}
              variant="warning"
              size="sm"
              className="toc_delete_btn"
              onClick={this.createClicked}
            >
              <span className="fa fa-plus" />
            </Button>
            <Button
              disabled={isSaveLoading || idx === 1}
              variant="danger"
              size="sm"
              className="toc_delete_btn"
              onClick={this.deleteClicked}
            >
              <span className="fa fa-trash" />
            </Button>
          </Card.Header>
          <Card.Body style={{ paddingTop: "0", paddingBottom: "0" }}>
            <Row>
              <Col
                xs="9"
                sm="9"
                md="9"
                lg="9"
                xl="9"
                style={{ padding: "5px" }}
              >
                <Form.Control
                  ref={el => (this.tocTitleRef = el)}
                  as="textarea"
                  size="sm"
                  type="text"
                  onFocus={this.focus}
                  disabled={idx === 1}
                  //onBlur={this.blur}
                  style={{ height: 70 }}
                  value={article.title}
                  onChange={this.onTitleChange}
                />
              </Col>
              <Col
                xs="3"
                sm="3"
                md="3"
                lg="3"
                xl="3"
                style={{ padding: "5px" }}
              >
                <Form.Control
                  className="edit_toc_article_page_form"
                  size="sm"
                  onFocus={this.focus}
                  //onBlur={this.blur}
                  value={article.first_page}
                  onChange={this.onStartPageChange}
                />
                <Form.Control
                  className="edit_toc_article_page_form"
                  size="sm"
                  onFocus={this.focus}
                  //onBlur={this.blur}
                  value={article.last_page}
                  onChange={this.onEndPageChange}
                />
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Draggable>
    );
  }
}

function getRelXY(e, panelPosition) {
  const mousePosition = getClientPos(e);

  return {
    x: mousePosition.x - panelPosition.x,
    y: mousePosition.y - panelPosition.y + panelPosition.scrollTop
  };
}

function getClientPos(e) {
  let clientX;
  let clientY;

  if (e.touches) {
    [{ clientX, clientY }] = e.touches;
  } else {
    ({ clientX, clientY } = e);
  }

  return {
    x: clientX,
    y: clientY
  };
}

const mapState = (state, ownProps) => {
  const { tocEditPanel } = state;
  const { articleID } = ownProps;
  const { articlesDict } = tocEditPanel.editHistory[
    tocEditPanel.editHistory.length - 1
  ];

  return {
    article: articlesDict[articleID],
    isSaveLoading: tocEditPanel.isSaveLoading,
    lockingID: tocEditPanel.lockingID
  };
};

const mapDispatch = {
  modifyOneTocDataAction,
  snapShotTocStateAction,
  recoverLastMoveAction,
  deleteTocArticleAction,
  setLockingIDAction,
  createManualArticleAction,
  saveTempTocAction
};

export default connect(
  mapState,
  mapDispatch
)(TocListItem);
